module.exports = __webpack_public_path__ + "4cec569b058292d325684e26a37c40cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-sounano.png
// module id = 2085
// module chunks = 4